import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: " श्री. अनिल विठ्ठया  घाटाळ ", designation: "गट ग्रामपंचायत वेती /वरोती ", phone: "+91 7387240330", imageUrl: "/images/anil.jpeg" },
  { name: "श्रीम. स्नेहल सागर घाटाळ", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 7030972018", imageUrl: "/images/shnehal.jpeg" },
  { name: "श्री. कैलाश पांडुरंग बसवत", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 7620466216", imageUrl: "/images/kailash.jpeg" },
  { name: "श्री. राजेश काशिनाथ इभाड", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 7378301087", imageUrl: "/images/rajesh.jpeg" },
  { name: "श्रीम. संजना सूरज गहला", designation: " गट ग्रामपंचायत वेती /वरोती ", phone: "+91 9209202356", imageUrl: "/images/sanjana.jpeg" },
  { name: "श्री. निलेश काकड्या कामडी ", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 9834059092", imageUrl: "/images/nilesh.jpeg" },
  { name: "श्रीम. कमल शांताराम डोकफोडे", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 7058602973", imageUrl: "/images/kamal.jpeg" },
  { name: "श्रीम. सुनिता सुरेश दांडेकर", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 7798099924", imageUrl: "/images/sunita.jpeg" },
  { name: "श्रीम. श्वेता बबन भोईर", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 7448227475", imageUrl: "/images/sweta.jpeg" },
  { name: "श्रीम. सुवर्णा कृष्णा डोकफोडे", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 9765548833", imageUrl: "/images/suvarna.jpeg" },
  { name: " श्री. अंकुश अनंत भोईर", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 9273114254", imageUrl: "/images/ankush.jpeg" },
  { name: "श्रीम. पिंकी विनोद बेलकर", designation: "गट ग्रामपंचायत वेती /वरोती", phone: "+91 9284196410", imageUrl: "/images/pinki.jpeg" },

];

const karmachariMembers = [
  /*{ name: " श्री. ", designation: "सफाई  कर्मचारी", imageUrl: "/images/sharad.jpeg" },
  { name: "श्री.  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/puru.jpeg" },
  { name: "श्री.", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/nikhil.jpeg" },
  { name: "श्री.", designation: "संगणक परिचालक", imageUrl: "/images/pritam.jpeg" },
  { name: "श्री.", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/ajay.jpeg" },*/
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">कर्मचारी</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
